import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthenticationService } from '../shared/service/authentication.service'
import { ExternalRedirectService } from '../shared/service/external-redirect.service'
import { MaintenanceService } from '../shared/service/maintenance.service'
import { MaintenanceDto } from '../shared/model/maintenance.model'
import { filterOkMapBody } from '../shared/util/http.utils'
import { map } from 'rxjs/operators'

export const AuthGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(AuthenticationService)
  const externalRedirectService = inject(ExternalRedirectService)
  const maintenanceService = inject(MaintenanceService)
  const isAdminLogin = authenticationService.currentUserValue ? authenticationService.currentUserValue.allowAdminLogin : false

  return maintenanceService.getMaintenanceInfos().pipe(
    filterOkMapBody,
    map((data: MaintenanceDto) => {
      const isMaintenanceActive = data.isActive
      if (isMaintenanceActive && !isAdminLogin) {
        externalRedirectService.triggerMaintenance()
        return false
      } else {
        if (authenticationService.currentUserValue) {
          return true
        } else {
          externalRedirectService.triggerLogin()
          return false
        }
      }
    })
  )
}
